/* Angular Component */
import { Component, Input, Output, EventEmitter } from "@angular/core";
import { UI } from "../../../services/ui.service";

@Component({
  selector: "library-header-filter",
  templateUrl: "./libraryHeaderFilter.component.html",
  styleUrls: ["./libraryHeaderFilter.component.scss"],
})
export class LibraryHeaderFilterComponent {
  @Input()
  filterToggleCallback;

  @Input()
  isFilterActive = false;

  @Output()
  onFilterClick = new EventEmitter();

  /**
   * Building the event
   * @param ui
   */
  constructor(private ui: UI) {}

  /**
   * Component init
   * @return void
   */
  ngOnInit() {
    /* Prepare Callback Function */
    this.filterToggleCallback = this.filterToggle.bind(this);
  }

  /**
   * Detect changes in one of the targets
   * @param changes
   */
  ngOnChanges(changes) {
    /* Updating filter visuals */
    if (changes.isFilterActive)
      this.onStateUpdate(changes.isFilterActive.currentValue);
  }

  /**
   * On state update function
   * @param newState
   * @return
   */
  onStateUpdate(newState) {}

  /**
   * Toggling the click
   * @return void
   */
  filterToggle() {
    this.onFilterClick.emit();
  }
}
